(() => {
  const rail = document.querySelector('[data-pairs]');
  if (!rail) return;

  const url = rail.dataset.pairsUrl;
  if (!url) return;

  // The endpoint answers with the section markup, not JSON, because the section
  // renders the products with this theme's own card. product_id is required:
  // without it the endpoint has nothing to recommend against and returns an
  // empty section on every product page.
  fetch(url)
    .then((response) => (response.ok ? response.text() : null))
    .then((html) => {
      if (!html) return;

      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-pairs]');

      // No card means no pairings have been set for this product, which is the
      // normal case until someone sits down with the Search & Discovery app.
      // The row stays hidden rather than showing an empty heading.
      if (!fresh || !fresh.querySelector('.pcard')) return;

      rail.innerHTML = fresh.innerHTML;
      rail.hidden = false;
    })
    .catch(() => {
      /* a hidden row is the right outcome when the request fails */
    });
})();
